import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'
import { serviceWithHeader } from '../request'

export const getConfirmationList = (params) => {
    return request({
        url: requestUrl('/client/confirmation/queryInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryHomePageConfirmation = (params) => {
    return request({
        url: requestUrl('/client/confirmation/queryHomePageConfirmation'),
        method: 'post',
        data: requestParam(params)
    })
}
export const getDashboard = (params) => {
    return request({
        url: requestUrl('/client/confirmation/dashboard/query'),
        method: 'post',
        data: requestParam(params)
    })
}
export const exportProgressByEntity = (params) => {
    return request({
        url: requestUrl('/client/confirmation/dashboard/exportProgressByEntity'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
export const exportPendingAnalyse = (params) => {
    return request({
        url: requestUrl('/client/confirmation/dashboard/query/pendingAnalyse/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const sendComments = (params) => {
    return request({
        url: requestUrl('/client/confirmationMessage'),
        method: 'post',
        data: requestParam(params)
    })
}

export const deleteComments = (params) => {
    return request({
        url: requestUrl('/client/confirmationMessage'),
        method: 'delete',
        data: requestParam(params)
    })
}
export const getEntity = (params) => {
    return request({
        url: requestUrl('/client/confirmation/queryEntity'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getQueryCondition = (params) => {
    return request({
        url: requestUrl('/client/confirmation/dashboard/queryCondition'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updateInfoBatch = (params) => {
    return request({
        url: requestUrl('/client/confirmation/updateInfoBatch'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updateCourierNo = (params) => {
    return request({
        url: requestUrl('/client/confirmation/updateCourierNo'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updateStatus = (params) => {
    return request({
        url: requestUrl('/client/confirmation/updateStatus'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getListQueryCondition = (params) => {
    return request({
        url: requestUrl('/client/confirmation/list/queryCondition'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryDict = (params) => {
    return request({
        url: requestUrl('/client/confirmation/list/queryDict'),
        method: 'post',
        data: requestParam(params)
    })
}

export const queryEntity = (params) => {
    return request({
        url: requestUrl('/client/confirmation/queryEntity'),
        method: 'post',
        data: requestParam(params)
    })
}

export const exportList = (params) => {
    return request({
        url: requestUrl('/client/confirmation/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
export const getPdfOut = (params) => {
    return serviceWithHeader({
        url: requestUrl('/client/confirmation/getPdfOut'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
export const getPdfDownloadBatch = (params) => {
    return request({
        url: requestUrl('/client/confirmation/getPdfDownloadBatch'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const printPdf = (params) => {
    return request({
        url: requestUrl('/client/confirmation/print'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

// ticket 启用、弃用
export const ticketList = (params) => {
    return request({
        url: requestUrl('/client/confirmation/list/ticket'),
        method: 'post',
        data: requestParam(params)
    })
}

// 长时间待处理的函证分析
export const pendingAnalyse = (params) => {
    return request({
        url: requestUrl('/client/confirmation/dashboard/query/pendingAnalyse'),
        method: 'post',
        data: requestParam(params)
    })
}
export const replyRate = (params) => {
    return request({
        url: requestUrl('/client/confirmation/dashboard/query/replyRate'),
        method: 'post',
        data: requestParam(params)
    })
}
export const reprint = (params) => {
    return request({
        url: requestUrl('/client/confirmation/reprint'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryTodayCount  = (params) => {
    return request({
        url: requestUrl('/client/confirmationMessage/queryTodayCount'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryTodayCommentInfos = (params) => {
    return request({
        url: requestUrl('/client/confirmation/queryTodayCommentInfos'),
        method: 'post',
        data: requestParam(params)
    })
}
